import { all, call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { generatePath } from 'react-router';

import api from '@api';
import { putError, putWarning } from '@utils/notificationUtils';
import { AuthorRoutePaths } from '@routes/routesPaths';

import { createAuthor, deleteAuthor, fetchAuthorList, updateAuthor } from './author.actions';
import { LoadersNames } from '../../ui/ui.actions';
import { uiActions } from '../../actions';

export function* authorListSaga() {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.author.authorListQuery);
    yield put(fetchAuthorList.done({ params: {}, result }));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_getting_author_list');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* createAuthorSaga({ payload }: ReturnType<typeof createAuthor.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.author.createAuthorMutation, payload);
    yield put(createAuthor.done({ params: payload, result }));
    yield put(push(AuthorRoutePaths.authorRoot));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_creating_author');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* updateAuthorSaga({ payload }: ReturnType<typeof updateAuthor.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.author.updateAuthorMutation, payload);
    yield put(updateAuthor.done({ params: payload, result }));
    yield put(push(generatePath(AuthorRoutePaths.authorRoot)));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_updating_author');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* deleteAuthorSaga({ payload }: ReturnType<typeof deleteAuthor.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.author.deleteAuthorMutation, payload);
    yield put(deleteAuthor.done({ params: payload, result }));
    yield put(push(AuthorRoutePaths.authorRoot));
    yield putWarning('app:msg_title_deleted', 'app:msg_author_deleted');
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_deleting_author');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* watchAuthorSaga() {
  yield all([
    yield takeLatest(fetchAuthorList.started, authorListSaga),
    yield takeLatest(createAuthor.started, createAuthorSaga),
    yield takeLatest(updateAuthor.started, updateAuthorSaga),
    yield takeLatest(deleteAuthor.started, deleteAuthorSaga),
  ]);
}
